import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "vue-screenshots" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { onMounted, ref, onUnmounted, computed, watch } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import CarouselPagination from '@/components/Carousel/CarouselPagination.vue';
import { Screenshots } from '@/types/manuals';
import ArrowLeft from '@/components/icons/CarouselLeft.vue';

const gap = 4;

export default /*@__PURE__*/_defineComponent({
  __name: 'Screenshots',
  props: {
    list: {}
  },
  setup(__props: any) {

const props = __props;

const currentSlide = ref(0);
const fullscreenImageRef = ref();
const carouselRef = ref();
const paginationRef = ref();
const deviceWidth = ref();
const isFullScreen = ref(false);
const isAllImagesVisible = ref(false);
const isFirstImage = computed(() => carouselRef.value?.minSlide === currentSlide.value);
const isLastImage = computed(() => carouselRef.value?.maxSlide === currentSlide.value);
const fullscreenImage = computed(() => props.list[currentSlide.value].file);
const loadedImagesCount = ref(0);
const allImagesLoaded = computed(() => loadedImagesCount.value === props.list.length);

const handleImageLoad = () => {
  loadedImagesCount.value++;
};

const galleryConfig = {
  wrapAround: false,
  itemsToShow: 1,
  height: 452,
  mouseDrag: false,
  touchDrag: false,
  slideEffect: 'fade',
};
const thumbnailsConfig = {
  wrapAround: false,
  gap,
  itemsToShow: 'auto',
  snapAlign: 'start',
  touchDrag: true,
  mouseDrag: true,
  height: 'auto',
  dynamicSlides: true,
};

const openFullscreen = () => {
  isFullScreen.value = true;
  document.body.style.overflow = 'hidden';
};

const closeFullscreen = () => {
  isFullScreen.value = false;
  document.body.style.overflow = '';
};

const nextSlide = (event?: Event) => {
  event?.stopPropagation();
  if (isLastImage.value) {
    return false;
  }
  carouselRef.value.next();
};
const prevSlide = (event?: Event) => {
  event?.stopPropagation();
  if (isFirstImage.value) {
    return false;
  }
  carouselRef.value.prev();
};

const slideTo = (nextSlide: number) => {
  currentSlide.value = nextSlide;
  if (window.innerWidth < 577) {
    openFullscreen();
  }
};

const checkAllThumbnailsVisible = () => {
  if (!carouselRef.value || !props.list?.length) { return false; }
  const { slides } = carouselRef.value;
  let totalWidth = 0;
  slides.forEach((slide: Record<string, any>, i: number) => {
    const slideWidth = slides[i]?.vnode?.el?.offsetWidth || 0;
    totalWidth += slideWidth + gap;
  });
  isAllImagesVisible.value = totalWidth < carouselRef.value.viewport.offsetWidth;
  return isAllImagesVisible.value;
};

const resetThumbnails = () => {
  if (!carouselRef.value) { return; }
  carouselRef.value.slideTo(0, { transition: 0 });
};

const resizeAction = () => {
  carouselRef.value.updateSlideSize();
  resetThumbnails();
  deviceWidth.value = window.innerWidth;
  checkAllThumbnailsVisible();
};

const slideEnd = () => {
  paginationRef.value?.updVisibleCards();
};

let startX = 0;
const touchstartFullscreen = (e: any) => {
  startX = e.touches[0].clientX;
};
const touchmoveFullscreen = (e: any) => {
  const currentX = e.touches[0].clientX;
  const diffX = currentX - startX;
  const minMove = 10;

  if (Math.abs(diffX) > minMove) {
    if (diffX > 0) {
      prevSlide();
    } else {
      nextSlide();
    }
  }
};

watch(() => allImagesLoaded.value, resizeAction);

onMounted(() => {
  fullscreenImageRef.value.addEventListener('touchstart', touchstartFullscreen);
  fullscreenImageRef.value.addEventListener('touchmove', touchmoveFullscreen);
  deviceWidth.value = window.innerWidth;
  window.addEventListener('resize', resizeAction);
  setTimeout(() => {
    resizeAction();
  }, 1000);
});

onUnmounted(() => {
  window.removeEventListener('resize', resizeAction);
  fullscreenImageRef.value?.removeEventListener('touchstart', touchstartFullscreen);
  fullscreenImageRef.value?.removeEventListener('touchmove', touchmoveFullscreen);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Carousel), _mergeProps({ id: "gallery" }, galleryConfig, {
      modelValue: currentSlide.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event)),
      class: "carousel__main"
    }), {
      addons: _withCtx(() => [
        _createVNode(_unref(Navigation))
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (image) => {
          return (_openBlock(), _createBlock(_unref(Slide), {
            key: image.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: image.file,
                alt: "Gallery Image",
                class: "gallery-image",
                onClick: openFullscreen
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 16, ["modelValue"]),
    _createVNode(_unref(Carousel), _mergeProps({
      id: "thumbnails",
      ref_key: "carouselRef",
      ref: carouselRef
    }, thumbnailsConfig, {
      modelValue: currentSlide.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSlide).value = $event)),
      class: { isFreeze: isAllImagesVisible.value },
      onSlideEnd: slideEnd
    }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (image) => {
          return (_openBlock(), _createBlock(_unref(Slide), {
            key: image.id,
            class: "slideEl"
          }, {
            default: _withCtx(({ currentIndex, isActive }) => [
              _createElementVNode("div", {
                class: _normalizeClass(['thumbnail', { 'is-active': isActive }]),
                onClick: ($event: any) => (slideTo(currentIndex))
              }, [
                _createElementVNode("img", {
                  src: image.file,
                  class: "thumbnail-image",
                  onLoad: handleImageLoad
                }, null, 40, _hoisted_4)
              ], 10, _hoisted_3)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 16, ["modelValue", "class"]),
    _createVNode(CarouselPagination, {
      ref_key: "paginationRef",
      ref: paginationRef,
      carouselRef: carouselRef.value
    }, null, 8, ["carouselRef"]),
    _withDirectives(_createElementVNode("div", {
      class: "fullscreen",
      onClick: closeFullscreen
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["fullscreen__arrow fullscreen__prev", { disabled: isFirstImage.value }]),
        onClick: prevSlide
      }, [
        _createVNode(ArrowLeft)
      ], 2),
      _createElementVNode("img", {
        ref_key: "fullscreenImageRef",
        ref: fullscreenImageRef,
        src: fullscreenImage.value,
        class: "fullscreen__image",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, null, 8, _hoisted_5),
      _createElementVNode("div", {
        class: _normalizeClass(["fullscreen__arrow fullscreen__next", { disabled: isLastImage.value }]),
        onClick: nextSlide
      }, [
        _createVNode(ArrowLeft)
      ], 2)
    ], 512), [
      [_vShow, isFullScreen.value]
    ])
  ]))
}
}

})